export enum Day {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}

/** EnumSelect uses string keys; numeric enum values are invalid select values. */
export function dayEnumSelectValue(
  day: number | null | undefined,
): keyof typeof Day {
  if (day != null && typeof Day[day] === "string") {
    return Day[day] as keyof typeof Day;
  }
  return "MONDAY";
}
